// Fritz Kamm AG · Übersetzungs-Wörterbuch
// Fachlich geprüfte Galvanik-Terminologie für DE / FR / EN / IT.
// Quellen: ISO 9001/14001 Standardvokabular, Galvanotechnik-Fachglossare,
// Schweizer Industrie-Standardterminologie.
//
// Wenn ein Schlüssel in einer Sprache fehlt, fällt das System automatisch auf DE zurück.

const translations = {
  // ==================== DEUTSCH ==================== //
  de: {
    nav: {
      ueber: "Über uns",
      verfahren: "Verfahren",
      finder: "Finder",
      preis: "Preis-Rechner",
      ki_analyse: "KI-Analyse",
      werkstour: "Werkstour",
      live: "Live",
      fabrik: "Fabrik-Karte",
      routen: "Routen",
      voice: "Voice",
      jobs: "Jobs",
      geschichte: "Geschichte",
      glossar: "Glossar",
      team: "Team",
      kontakt: "Kontakt",
      cta: "Offerte einholen",
    },
    hero: {
      overline: "FRITZ KAMM AG · Galvanik · Schweiz",
      headline_1: "Ihr Partner für",
      headline_2: "Metallveredelungen",
      headline_3: "und Material-Finishing.",
      sub:
        "Die Fritz Kamm AG zählt zu den führenden Galvanik-Unternehmen der Schweiz. Unser Leitziel — Qualität und Termin — bestimmt jeden Arbeitsschritt.",
      cta_primary: "Offerte einholen",
      cta_secondary: "Verfahren ansehen",
      stat_verfahren: "Veredelungsverfahren",
      stat_iso: "& ISO 14001 zertifiziert",
      stat_tradition: "Schweizer Tradition seit",
      stat_co2: "Emissionen reduziert",
    },
    sections: {
      ueber_overline: "— Über uns",
      ueber_title_1: "Eine Schweizer Adresse",
      ueber_title_2: "für Galvanik.",
      verfahren_overline: "— Verfahren",
      verfahren_title_1: "Elf Verfahren.",
      verfahren_title_2: "Ein Massstab.",
      finder_overline: "— Verfahren-Finder",
      finder_title_1: "Finden Sie in 30 Sekunden",
      finder_title_2: "Ihr passendes Verfahren.",
      vergleich_overline: "— Verfahren-Vergleich",
      vergleich_title_1: "Zwei Verfahren.",
      vergleich_title_2: "Eine klare Entscheidung.",
      warum_overline: "— Warum Fritz Kamm AG",
      warum_title_1: "Vertrauen wird",
      warum_title_2: "gemacht. Nicht versprochen.",
      anwendungen_overline: "— Anwendungsbereiche",
      anwendungen_title_1: "Wo unsere",
      anwendungen_title_2: "Oberflächen arbeiten.",
      ablauf_overline: "— Ablauf",
      ablauf_title_1: "Von der Anfrage",
      ablauf_title_2: "bis zur Auslieferung.",
      geschichte_overline: "— Geschichte · seit 1968",
      geschichte_title_1: "Über fünf Jahrzehnte",
      geschichte_title_2: "Schweizer Galvanik.",
      team_overline: "— Team",
      team_title_1: "Menschen,",
      team_title_2: "die für Qualität stehen.",
      zertifikate_overline: "— Zertifikate",
      zertifikate_title_1: "Geprüft. Dokumentiert.",
      zertifikate_title_2: "Schweizer Standard.",
      glossar_overline: "— Galvanik-Glossar · FAQ",
      glossar_title_1: "Fachbegriffe",
      glossar_title_2: "verständlich erklärt.",
      kontakt_overline: "— Kontakt",
      kontakt_title_1: "Holen Sie eine Offerte",
      kontakt_title_2: "auf Sie zugeschnitten ein.",
      ablauf_step: "Schritt",
      geschichte_milestone: "Meilenstein",
    },
    footer: {
      tagline_1: "Qualität und Termin —",
      tagline_2: "seit Generationen Schweizer Galvanik.",
      navigation: "Navigation",
      location: "Standort",
      hours_1: "Mo–Do · 07–17 Uhr",
      hours_2: "Fr · 07–16 Uhr",
      rights: "Alle Rechte vorbehalten.",
      imprint: "Impressum",
      privacy: "Datenschutz",
      agb: "AGB",
      credit_prefix: "Designt & entwickelt von",
    },
    services: {
      hauptverfahren: "Hauptverfahren",
    },
    form: {
      name: "Name",
      email: "E-Mail",
      company: "Firma",
      phone: "Telefon",
      service: "Verfahren",
      message: "Nachricht",
      attachment: "Bauteilzeichnung (optional)",
      consent:
        "Ja, ich akzeptiere die Datenschutzerklärung. Meine Anfrage wird ausschliesslich zur Bearbeitung durch die Fritz Kamm AG genutzt.",
      submit: "Anfrage senden",
      sending: "Wird gesendet…",
      success_title: "Anfrage erhalten.",
      success_body:
        "Vielen Dank. Ein Mitarbeiter der Fritz Kamm AG meldet sich innerhalb eines Werktags persönlich bei Ihnen.",
      success_again: "Weitere Anfrage senden",
    },
    common: {
      back: "Zurück",
      open: "Öffnen",
      close: "Schliessen",
      print_pdf: "Als PDF speichern",
      mels: "Mels · Schweiz",
      switzerland: "Schweiz",
    },
    cookie: {
      label: "— Datenschutz",
      body:
        "Diese Website verwendet ausschliesslich technisch notwendige Cookies sowie anonyme Statistik. Es werden keine Daten an Dritte verkauft.",
      essential: "Nur notwendige",
      accept_all: "Alle akzeptieren",
      privacy_link: "Datenschutzerklärung lesen",
    },
  },

  // ==================== FRANÇAIS ==================== //
  fr: {
    nav: {
      ueber: "À propos",
      verfahren: "Procédés",
      finder: "Sélecteur",
      preis: "Calculateur prix",
      ki_analyse: "Analyse IA",
      werkstour: "Visite d'usine",
      live: "Live",
      fabrik: "Plan d'usine",
      routen: "Tournées",
      voice: "Voix",
      jobs: "Emplois",
      geschichte: "Histoire",
      glossar: "Glossaire",
      team: "Équipe",
      kontakt: "Contact",
      cta: "Demander un devis",
    },
    hero: {
      overline: "FRITZ KAMM SA · Galvanoplastie · Suisse",
      headline_1: "Votre partenaire pour le",
      headline_2: "traitement de surface",
      headline_3: "et la finition des métaux.",
      sub:
        "Fritz Kamm SA figure parmi les principales entreprises de galvanoplastie en Suisse. Notre exigence — qualité et délais — guide chaque étape du processus.",
      cta_primary: "Demander un devis",
      cta_secondary: "Voir les procédés",
      stat_verfahren: "Procédés de finition",
      stat_iso: "& ISO 14001 certifié",
      stat_tradition: "Tradition suisse depuis",
      stat_co2: "émissions réduites",
    },
    sections: {
      ueber_overline: "— À propos",
      ueber_title_1: "Une référence suisse",
      ueber_title_2: "en galvanoplastie.",
      verfahren_overline: "— Procédés",
      verfahren_title_1: "Onze procédés.",
      verfahren_title_2: "Une exigence.",
      finder_overline: "— Sélecteur de procédé",
      finder_title_1: "Trouvez en 30 secondes",
      finder_title_2: "le procédé qui vous convient.",
      vergleich_overline: "— Comparatif des procédés",
      vergleich_title_1: "Deux procédés.",
      vergleich_title_2: "Une décision claire.",
      warum_overline: "— Pourquoi Fritz Kamm SA",
      warum_title_1: "La confiance se",
      warum_title_2: "construit. Elle ne se promet pas.",
      anwendungen_overline: "— Domaines d'application",
      anwendungen_title_1: "Là où nos",
      anwendungen_title_2: "surfaces font leur travail.",
      ablauf_overline: "— Déroulement",
      ablauf_title_1: "De la demande",
      ablauf_title_2: "à la livraison.",
      geschichte_overline: "— Histoire · depuis 1968",
      geschichte_title_1: "Plus de cinq décennies",
      geschichte_title_2: "de galvanoplastie suisse.",
      team_overline: "— Équipe",
      team_title_1: "Des personnes",
      team_title_2: "qui incarnent la qualité.",
      zertifikate_overline: "— Certifications",
      zertifikate_title_1: "Contrôlé. Documenté.",
      zertifikate_title_2: "Standard suisse.",
      glossar_overline: "— Glossaire · FAQ",
      glossar_title_1: "Termes techniques",
      glossar_title_2: "expliqués clairement.",
      kontakt_overline: "— Contact",
      kontakt_title_1: "Demandez un devis",
      kontakt_title_2: "adapté à votre projet.",
      ablauf_step: "Étape",
      geschichte_milestone: "Étape",
    },
    footer: {
      tagline_1: "Qualité et délais —",
      tagline_2: "la galvanoplastie suisse depuis des générations.",
      navigation: "Navigation",
      location: "Site",
      hours_1: "Lun–Jeu · 7h–17h",
      hours_2: "Ven · 7h–16h",
      rights: "Tous droits réservés.",
      imprint: "Mentions légales",
      privacy: "Confidentialité",
      agb: "CGV",
      credit_prefix: "Conçu & développé par",
    },
    services: {
      hauptverfahren: "Procédé phare",
    },
    form: {
      name: "Nom",
      email: "E-mail",
      company: "Société",
      phone: "Téléphone",
      service: "Procédé",
      message: "Message",
      attachment: "Plan de pièce (facultatif)",
      consent:
        "J'accepte la politique de confidentialité. Ma demande sera utilisée exclusivement par Fritz Kamm SA pour son traitement.",
      submit: "Envoyer la demande",
      sending: "Envoi en cours…",
      success_title: "Demande reçue.",
      success_body:
        "Merci. Un collaborateur de Fritz Kamm SA vous contactera personnellement dans le délai d'un jour ouvré.",
      success_again: "Envoyer une autre demande",
    },
    common: {
      back: "Retour",
      open: "Ouvrir",
      close: "Fermer",
      print_pdf: "Enregistrer en PDF",
      mels: "Mels · Suisse",
      switzerland: "Suisse",
    },
    cookie: {
      label: "— Confidentialité",
      body:
        "Ce site utilise uniquement des cookies techniques nécessaires et des statistiques anonymes. Aucune donnée n'est vendue à des tiers.",
      essential: "Uniquement essentiels",
      accept_all: "Tout accepter",
      privacy_link: "Lire la politique de confidentialité",
    },
  },

  // ==================== ENGLISH ==================== //
  en: {
    nav: {
      ueber: "About",
      verfahren: "Processes",
      finder: "Finder",
      preis: "Price calculator",
      ki_analyse: "AI analysis",
      werkstour: "Factory tour",
      live: "Live",
      fabrik: "Floor plan",
      routen: "Routes",
      voice: "Voice",
      jobs: "Careers",
      geschichte: "Heritage",
      glossar: "Glossary",
      team: "Team",
      kontakt: "Contact",
      cta: "Request a quote",
    },
    hero: {
      overline: "FRITZ KAMM AG · Electroplating · Switzerland",
      headline_1: "Your partner for",
      headline_2: "metal finishing",
      headline_3: "and surface engineering.",
      sub:
        "Fritz Kamm AG is one of Switzerland's leading electroplating companies. Our guiding principle — quality and on-time delivery — defines every step of the process.",
      cta_primary: "Request a quote",
      cta_secondary: "View processes",
      stat_verfahren: "Finishing processes",
      stat_iso: "& ISO 14001 certified",
      stat_tradition: "Swiss tradition since",
      stat_co2: "emissions reduced",
    },
    sections: {
      ueber_overline: "— About",
      ueber_title_1: "A Swiss address",
      ueber_title_2: "for electroplating.",
      verfahren_overline: "— Processes",
      verfahren_title_1: "Eleven processes.",
      verfahren_title_2: "One standard.",
      finder_overline: "— Process Finder",
      finder_title_1: "Find your right process",
      finder_title_2: "in 30 seconds.",
      vergleich_overline: "— Process comparison",
      vergleich_title_1: "Two processes.",
      vergleich_title_2: "One clear decision.",
      warum_overline: "— Why Fritz Kamm AG",
      warum_title_1: "Trust is",
      warum_title_2: "engineered. Not advertised.",
      anwendungen_overline: "— Application areas",
      anwendungen_title_1: "Where our",
      anwendungen_title_2: "surfaces deliver.",
      ablauf_overline: "— Workflow",
      ablauf_title_1: "From inquiry",
      ablauf_title_2: "to delivery.",
      geschichte_overline: "— Heritage · since 1968",
      geschichte_title_1: "Over five decades",
      geschichte_title_2: "of Swiss electroplating.",
      team_overline: "— Team",
      team_title_1: "People who",
      team_title_2: "stand for quality.",
      zertifikate_overline: "— Certifications",
      zertifikate_title_1: "Audited. Documented.",
      zertifikate_title_2: "Swiss standard.",
      glossar_overline: "— Electroplating glossary · FAQ",
      glossar_title_1: "Technical terms",
      glossar_title_2: "explained clearly.",
      kontakt_overline: "— Contact",
      kontakt_title_1: "Request a quote",
      kontakt_title_2: "tailored to your project.",
      ablauf_step: "Step",
      geschichte_milestone: "Milestone",
    },
    footer: {
      tagline_1: "Quality and on-time —",
      tagline_2: "Swiss electroplating for generations.",
      navigation: "Navigation",
      location: "Location",
      hours_1: "Mon–Thu · 7am–5pm",
      hours_2: "Fri · 7am–4pm",
      rights: "All rights reserved.",
      imprint: "Imprint",
      privacy: "Privacy",
      agb: "T&C",
      credit_prefix: "Designed & built by",
    },
    services: {
      hauptverfahren: "Featured process",
    },
    form: {
      name: "Name",
      email: "Email",
      company: "Company",
      phone: "Phone",
      service: "Process",
      message: "Message",
      attachment: "Component drawing (optional)",
      consent:
        "I accept the privacy policy. My inquiry will be used exclusively by Fritz Kamm AG for processing.",
      submit: "Send request",
      sending: "Sending…",
      success_title: "Request received.",
      success_body:
        "Thank you. A Fritz Kamm AG representative will personally respond within one business day.",
      success_again: "Submit another request",
    },
    common: {
      back: "Back",
      open: "Open",
      close: "Close",
      print_pdf: "Save as PDF",
      mels: "Mels · Switzerland",
    },
    cookie: {
      label: "— Privacy",
      body:
        "This website only uses technically necessary cookies and anonymous statistics. No data is sold to third parties.",
      essential: "Essential only",
      accept_all: "Accept all",
      privacy_link: "Read privacy policy",
    },
  },

  // ==================== ITALIANO ==================== //
  it: {
    nav: {
      ueber: "Chi siamo",
      verfahren: "Procedimenti",
      finder: "Selettore",
      preis: "Calcolatore prezzo",
      ki_analyse: "Analisi IA",
      werkstour: "Visita officina",
      live: "Live",
      fabrik: "Pianta",
      routen: "Tratte",
      voice: "Voce",
      jobs: "Lavoro",
      geschichte: "Storia",
      glossar: "Glossario",
      team: "Team",
      cta: "Richiedi un'offerta",
    },
    hero: {
      overline: "FRITZ KAMM SA · Galvanica · Svizzera",
      headline_1: "Il vostro partner per il",
      headline_2: "trattamento delle superfici",
      headline_3: "e la finitura dei metalli.",
      sub:
        "Fritz Kamm SA è tra le principali aziende galvaniche della Svizzera. Il nostro obiettivo — qualità e puntualità — guida ogni fase del processo.",
      cta_primary: "Richiedi un'offerta",
      cta_secondary: "Vedi i procedimenti",
      stat_verfahren: "Procedimenti di finitura",
      stat_iso: "& ISO 14001 certificata",
      stat_tradition: "Tradizione svizzera dal",
      stat_co2: "emissioni ridotte",
    },
    sections: {
      ueber_overline: "— Chi siamo",
      ueber_title_1: "Un indirizzo svizzero",
      ueber_title_2: "per la galvanica.",
      verfahren_overline: "— Procedimenti",
      verfahren_title_1: "Undici procedimenti.",
      verfahren_title_2: "Un unico standard.",
      finder_overline: "— Selettore di procedimento",
      finder_title_1: "Trovate in 30 secondi",
      finder_title_2: "il procedimento adatto.",
      vergleich_overline: "— Confronto tra procedimenti",
      vergleich_title_1: "Due procedimenti.",
      vergleich_title_2: "Una decisione chiara.",
      warum_overline: "— Perché Fritz Kamm SA",
      warum_title_1: "La fiducia si",
      warum_title_2: "costruisce. Non si promette.",
      anwendungen_overline: "— Settori d'impiego",
      anwendungen_title_1: "Dove le nostre",
      anwendungen_title_2: "superfici lavorano.",
      ablauf_overline: "— Iter",
      ablauf_title_1: "Dalla richiesta",
      ablauf_title_2: "alla consegna.",
      geschichte_overline: "— Storia · dal 1968",
      geschichte_title_1: "Oltre cinque decenni",
      geschichte_title_2: "di galvanica svizzera.",
      team_overline: "— Team",
      team_title_1: "Persone",
      team_title_2: "che incarnano la qualità.",
      zertifikate_overline: "— Certificazioni",
      zertifikate_title_1: "Verificato. Documentato.",
      zertifikate_title_2: "Standard svizzero.",
      glossar_overline: "— Glossario galvanica · FAQ",
      glossar_title_1: "Termini tecnici",
      glossar_title_2: "spiegati con chiarezza.",
      kontakt_overline: "— Contatti",
      kontakt_title_1: "Richiedete un'offerta",
      kontakt_title_2: "su misura per voi.",
    },
    form: {
      name: "Nome",
      email: "E-mail",
      company: "Azienda",
      phone: "Telefono",
      service: "Procedimento",
      message: "Messaggio",
      attachment: "Disegno del componente (facoltativo)",
      consent:
        "Accetto l'informativa sulla privacy. La mia richiesta verrà utilizzata esclusivamente da Fritz Kamm SA per la gestione.",
      submit: "Invia richiesta",
      sending: "Invio in corso…",
      success_title: "Richiesta ricevuta.",
      success_body:
        "Grazie. Un collaboratore di Fritz Kamm SA La contatterà entro un giorno lavorativo.",
      success_again: "Invia un'altra richiesta",
    },
    common: {
      back: "Indietro",
      open: "Apri",
      close: "Chiudi",
      print_pdf: "Salva come PDF",
      mels: "Mels · Svizzera",
    },
    cookie: {
      label: "— Privacy",
      body:
        "Questo sito utilizza esclusivamente cookie tecnicamente necessari e statistiche anonime. Nessun dato viene venduto a terzi.",
      essential: "Solo necessari",
      accept_all: "Accetta tutto",
      privacy_link: "Leggi l'informativa sulla privacy",
    },
  },
};

// Galvanik-Verfahren · zentrale Begriffe (für Verfahren-Karten und KI-Berater)
export const verfahrenLabels = {
  de: {
    Verzinken: "Verzinken",
    Trommelverzinken: "Trommelverzinken",
    "Zink-Nickel": "Zink-Nickel",
    "Zink-Mangan-Phosphatieren": "Zink-Mangan-Phosphatieren",
    "CNS-Beizen": "Edelstahl-Beizen",
    "CNS-Elektropolieren": "Edelstahl-Elektropolieren",
    "Schleifen · Bürsten": "Schleifen · Bürsten",
    Brünieren: "Brünieren",
    Vergolden: "Vergolden",
    "Chemisch-Nickel": "Chemisch Nickel",
    "Galvanisch-Nickel": "Galvanisch Nickel",
  },
  fr: {
    Verzinken: "Zingage électrolytique",
    Trommelverzinken: "Zingage en tonneau",
    "Zink-Nickel": "Zingage zinc-nickel",
    "Zink-Mangan-Phosphatieren": "Phosphatation zinc-manganèse",
    "CNS-Beizen": "Décapage de l'inox",
    "CNS-Elektropolieren": "Électropolissage de l'inox",
    "Schleifen · Bürsten": "Polissage · Brossage",
    Brünieren: "Brunissage",
    Vergolden: "Dorure galvanique",
    "Chemisch-Nickel": "Nickelage chimique",
    "Galvanisch-Nickel": "Nickelage électrolytique",
  },
  en: {
    Verzinken: "Electrogalvanizing",
    Trommelverzinken: "Barrel zinc plating",
    "Zink-Nickel": "Zinc-nickel plating",
    "Zink-Mangan-Phosphatieren": "Zinc-manganese phosphating",
    "CNS-Beizen": "Stainless steel pickling",
    "CNS-Elektropolieren": "Stainless steel electropolishing",
    "Schleifen · Bürsten": "Grinding · Brushing",
    Brünieren: "Black oxide (bluing)",
    Vergolden: "Gold electroplating",
    "Chemisch-Nickel": "Electroless nickel plating",
    "Galvanisch-Nickel": "Electrolytic nickel plating",
  },
  it: {
    Verzinken: "Zincatura elettrolitica",
    Trommelverzinken: "Zincatura a rotobarile",
    "Zink-Nickel": "Zincatura zinco-nichel",
    "Zink-Mangan-Phosphatieren": "Fosfatazione zinco-manganese",
    "CNS-Beizen": "Decapaggio inox",
    "CNS-Elektropolieren": "Elettrolucidatura inox",
    "Schleifen · Bürsten": "Levigatura · Spazzolatura",
    Brünieren: "Brunitura",
    Vergolden: "Doratura galvanica",
    "Chemisch-Nickel": "Nichelatura chimica",
    "Galvanisch-Nickel": "Nichelatura galvanica",
  },
};

export default translations;
